// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","white":"#ffffff","scrollable":"_3quDsIu","with_left_margin":"_3QhbC8k","with_right_padding":"_3j0VcBo","with_white_background":"_2bNY-fe"};